export default __webpack_public_path__ + "static/media/AppraisalWF2.5d2d13e5.png";